/// <amd-module name="Environments/EnvironmentTraceabilityChanges/ActionsCreators/CommitsActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { CommitsActions } from "Environments/EnvironmentTraceabilityChanges/Actions/CommitsActions";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";
import { ICommitsResult } from "Environments/Client/EnvironmentContracts";
import { IEnvironmentService } from "Environments/Client/EnvironmentService"

import { IVssPageContext } from "VSS/Platform/Context";

const CommitsView: string = "environments";

export class CommitsActionsCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "commits-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);
        
        this._actions = ActionsHubManager.CreateActionsHub<CommitsActions>(CommitsActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }


    public getCommits(pageContext: IVssPageContext): boolean {
        
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");
        let commitsResult: ICommitsResult | undefined = environmentService.getCommits();

        if (!!commitsResult) {
            this._actions.setCommits.invoke(commitsResult);
            return true;
        }

        environmentService.getCommitsAsync().then((commitsResult : ICommitsResult) => {
            this._actions.setCommits.invoke(commitsResult);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: CommitsView, value: error });
        });

        return false;
    }

    public getCommitsAsync(pageContext: IVssPageContext): boolean {
        
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");

        environmentService.getCommitsAsync("2500").then((commitsResult : ICommitsResult) => {
            this._actions.setCommits.invoke(commitsResult);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: CommitsView, value: error });
        });

        return false;
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<CommitsActions>(CommitsActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: CommitsActions;
    private _messageActions: MessagesActions;
}
